export function formatCountries(countryData: any): string {
  try {
    if (Array.isArray(countryData)) {
      return countryData.join(' ');
    }
    
    if (typeof countryData === 'string') {
      const parsed = JSON.parse(countryData);
      return Array.isArray(parsed) ? parsed.join(', ') : parsed;
    }
    
    return 'N/A';
  } catch (e) {
    console.error('Error formatting countries:', e);
    return 'N/A';
  }
}